export const setAuthState = (auth_state) => {
  return { type: "set_auth_state", payload: auth_state };
};
